import React from 'react';
import { ArrowUpRight } from 'lucide-react';

/**
 * Summary stat card with optional icon — used across lists and detail screens.
 *
 * Pass either `value` (number or string; numbers use en-IN locale) or `displayValue`
 * for fully custom content (e.g. formatted area + unit suffix).
 */
const MetricCard = ({
  title,
  value,
  displayValue,
  icon,
  iconBgClass = 'bg-[#ECF6F3]',
  iconColorClass = 'text-[#2A565E]',
  valueColorClass = 'text-[#111827]',
  borderClass = 'border-[#E6EBF1]',
  titleClassName = 'text-xs',
  valueClassName = 'text-2xl sm:text-3xl',
  showArrow = false,
  onClick,
  /** Tailwind width utilities; default fills grid/flex parent */
  widthClass = 'w-full',
  className = ''
}) => {
  let rendered;
  if (displayValue !== undefined && displayValue !== null) {
    rendered = displayValue;
  } else if (value !== undefined && value !== null && value !== '') {
    rendered = typeof value === 'number' ? value.toLocaleString('en-IN') : String(value);
  } else {
    rendered = '—';
  }

  return (
    <div
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={
        onClick
          ? (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onClick();
              }
            }
          : undefined
      }
      className={`relative ${widthClass} rounded-xl border ${borderClass} bg-white px-4 py-3 sm:px-5 sm:py-4 shadow-sm flex items-center gap-3 ${
        showArrow ? 'pr-10' : ''
      } ${onClick ? 'cursor-pointer transition hover:shadow-md' : ''} ${className}`.trim()}>
      <div className="flex items-center gap-4 min-w-0 flex-1">
        {icon ? (
          <div
            className={`hidden sm:flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ${iconBgClass} ${iconColorClass}`}>
            {icon}
          </div>
        ) : null}
        <div className="flex-1 min-w-0">
          <p
            className={`${titleClassName} font-medium text-gray-500 uppercase tracking-wide leading-tight`}>
            {title}
          </p>
          <div className={`mt-0.5 ${valueClassName} font-bold leading-none ${valueColorClass}`}>
            {rendered}
          </div>
        </div>
      </div>
      {showArrow ? (
        <span className="absolute bottom-2 right-2 inline-flex h-5 w-5 items-center justify-center rounded-full bg-customBlue/10 text-customBlue">
          <ArrowUpRight size={14} />
        </span>
      ) : null}
    </div>
  );
};

export default MetricCard;
